import { SelectInput } from "src/app/shared/dropdown/shared/select-input.class";

export enum ErrorLevel {
    Warning,
    Error,
    CriticalError,
    Unknown
}

export function getErrorLevelString(type: ErrorLevel): string {
    switch (type) {
        case ErrorLevel.Warning:
            return 'Warnung';
        case ErrorLevel.Error:
            return 'Fehler';
        case ErrorLevel.CriticalError:
            return 'Kritischer Fehler';
        case ErrorLevel.Unknown:
            return 'Unbekannt';
        default:
            return 'Unbekannt';
    }
}

export function getErrorLevelSelect(): SelectInput[] {
    return [
        { name: getErrorLevelString(ErrorLevel.Warning), id: 0 },
        { name: getErrorLevelString(ErrorLevel.Error), id: 1 },
        { name: getErrorLevelString(ErrorLevel.CriticalError), id: 2 },
        { name: getErrorLevelString(ErrorLevel.Unknown), id: 3 },
    ];
}